// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboOutlinedSvg from "@fishx/icons-svg/es/asn/WeiboOutlined";
import FishxIcon from '../components/FishxIcon';

var WeiboOutlined = function WeiboOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboOutlinedSvg
  }));
};

WeiboOutlined.displayName = 'WeiboOutlined';
export default React.forwardRef(WeiboOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WeiboOutlined.js
// module id = 4402
// module chunks = 0